import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { Box, TextField, Button, MenuItem, Dialog, DialogTitle, DialogContent } from '@mui/material';
import BaseCodeSelectbox from '../selectbox/BaseCodeSelectbox';
import PartnerAddPage from '../../../../pages/partnermng/PartnerAddPage';

export const PartnerListBox = ({ formik, link, isModal }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const toggleModal = (open) => () => {
    setModalOpen(open);
  };

  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
          alignItems: 'center',
          my: 1,
        }}
      >
        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: { xs: 'flex-start', md: 'flex-end' },
            alignItems: 'stretch',
            mr: { xs: 0, md: 2 },
            gap: { xs: 0.5, md: 0 }
          }}
          onSubmit={formik.handleSubmit}
        >
          {link && (
            <Box 
              sx={{ 
                order: { xs: -1, md: 3 }, 
                px: { xs: 0.5, md: 0 }, 
                mb: { xs: 0.5, md: 0 }, 
                width: { xs: '100%', md: 'auto' }
              }}
            >
              <Button
                color="warning"
                variant="contained"
                onClick={toggleModal(true)}
                sx={{ width: { xs: '100%', md: 'auto' }, m: { xs: 0, md: 1 } }} 
              >
                거래처 등록
              </Button>
            </Box>
          )}

          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              justifyContent: 'flex-start',
              alignItems: 'stretch',
              width: { xs: '100%', md: 'auto' },
              order: 1 
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
              <Box sx={{ mx: 0.5, my: 0.5, flex: { xs: 1, md: 'none' }, width: { md: '25ch' } }}>
                <BaseCodeSelectbox
                  formik={formik}
                  label="거래처 종류"
                  variant="standard"
                  required={false}
                  fullWidth
                  InputLabelProps={{ shrink: true }} 
                  filterObject={{
                    blcCd: 'BASE',
                    mlcCd: 'PARTNER',
                    slcCd: 'PARTNER_TYP',
                    useYn: 'Y',
                  }}
                  name="searchPartnerTyp"
                  size="small"
                />
              </Box>

              <Box sx={{ mx: 0.5, my: 0.5, flex: { xs: 1, md: 'none' }, width: { md: '25ch' } }}>
                <TextField
                  variant="standard"
                  required
                  select
                  fullWidth
                  id="searchKeyword"
                  name="searchKeyword"
                  label="검색키워드"
                  value={formik.values.searchKeyword}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.searchKeyword &&
                    Boolean(formik.errors.searchKeyword)
                  }
                  helperText={
                    formik.touched.searchKeyword && formik.errors.searchKeyword
                  }
                >
                  <MenuItem value="partnerNm">회사명</MenuItem>
                  <MenuItem value="regNumber">사업자번호</MenuItem>
                  <MenuItem value="partnerPhone">연락처</MenuItem>
                </TextField>
              </Box>
            </Box>
            <Box 
              sx={{ 
                display: 'flex', 
                flexDirection: 'row', 
                alignItems: 'flex-end', 
                width: '100%',
                mb: { xs: 0.5, md: 0 }
              }}
            >
              <Box sx={{ mx: 0.5, my: 0.5, flex: { xs: 7, md: 'none' }, width: { md: '25ch' } }}>
                <TextField
                  variant="standard"
                  required
                  fullWidth
                  id="searchWords"
                  name="searchWords"
                  label="검색어"
                  value={formik.values.searchWords || ''}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.searchWords && Boolean(formik.errors.searchWords)
                  }
                  helperText={
                    formik.touched.searchWords && formik.errors.searchWords
                  }
                />
              </Box>

              <Box sx={{ mx: 0.5, my: 0.5, flex: { xs: 3, md: 'none' }, display: { xs: 'block', md: 'none' } }}>
                <Button
                  type="submit"
                  color="info"
                  variant="contained"
                  disabled={formik.isSubmitting}
                  sx={{ width: '100%', height: '32px' }} 
                >
                  검색
                </Button>
              </Box>
            </Box>
          </Box>

          <Box sx={{ display: { xs: 'none', md: 'block' }, order: 2 }}>
            <Button
              type="submit"
              color="info"
              variant="contained"
              disabled={formik.isSubmitting}
              sx={{ width: 'auto', m: 1 }} 
            >
              검색
            </Button>
          </Box>
        </Box>
      </Box>

      {createPortal(
        <Dialog
          open={modalOpen}
          onClose={toggleModal(false)}
          disableEnforceFocus
          PaperProps={{
            sx: { 
              width: 1400,
              maxWidth: '95vw',
              m: 2
            }
          }}
        >
          <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontWeight: 'bold' }}>
            <span>거래처 등록</span>
            <Button variant="outlined" color="error" size="small" onClick={toggleModal(false)}>
              닫기
            </Button>
          </DialogTitle>
          
          <DialogContent dividers sx={{ p: 3, overflowY: 'auto' }}>
            <PartnerAddPage handleClose={toggleModal(false)} isModal={isModal} />
          </DialogContent>
        </Dialog>,
        document.body
      )}
    </div>
  );
};
